/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Landing_Operationstitle1Inputs */

const en_welcome_landing_operationstitle1 = /** @type {(inputs: Welcome_Landing_Operationstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your team`)
};

/**
* | output |
* | --- |
* | "Manage your team" |
*
* @param {Welcome_Landing_Operationstitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_landing_operationstitle1 = /** @type {((inputs?: Welcome_Landing_Operationstitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Landing_Operationstitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_landing_operationstitle1(inputs)
});
export { welcome_landing_operationstitle1 as "welcome_landing_operationsTitle" }